$(document).ready(function () {
    $('#important-documents-collapse').on('hide.bs.collapse', function () {
        $(this).siblings('button[href="#' + $(this).prop('id') + '"]').html('<i class="' + FontAwesome.prefix('regular', 'eye') + '"></i> See More');
    });
    $('#important-documents-collapse').on('show.bs.collapse', function () {
        $(this).siblings('button[href="#' + $(this).prop('id') + '"]').html('<i class="' + FontAwesome.prefix('regular', 'eye') + '"></i> See Less');
    });

    $('#key-info-collapse').on('hide.bs.collapse', function () {
        $(this).siblings('button[href="#' + $(this).prop('id') + '"]').html('<i class="' + FontAwesome.prefix('regular', 'eye') + '"></i> See More');
    });
    $('#key-info-collapse').on('show.bs.collapse', function () {
        $(this).siblings('button[href="#' + $(this).prop('id') + '"]').html('<i class="' + FontAwesome.prefix('regular', 'eye') + '"></i> See Less');
    });

    // Add actions to dismiss buttons
    $('.notification .close').bind('click', function () {
        // Make a call to our magical AJAX hider
        if (dismissurl) {
            var id = $(this).parents('.alert').data('id');
            $.get(dismissurl + '/' + id).fail(function (xhr, status, error) {
                Alert.error('Alert Dismiss Failed', 'Sorry, dismissing the alert failed: ' + xhr.responseText);
            });
        }
    });

    $(window).on('load resize', function () {
        if ($(window).width() < 768) {
            $('#sidebar').insertAfter($('#alertscontainer'));
        } else {
            $('#sidebar').insertAfter($('#content'));
        }
    });
});
